import { FC } from 'react';

import { ic_right } from '.';

const RightIcon: FC<{ width?: number }> = ({ width = 16 }) => {
  return <img src={ic_right} width={width} alt="" />;
};

export default RightIcon;
